export const verificationFormWrapper = {
  paddingBottom: 2,
  '.MuiAccordion-root': {
    marginBottom: '16px !important'
  }
};

export const accordionHeader = {
  borderBottom: '1px dotted #ccc',
  fontWeight: 'bold',
  '.MuiAccordionSummary-content': {
    justifyContent: 'space-between'
  }
};

export const accordionBackgound = {
  backgroundColor: '#f9f9f9'
};

export const activeAccordionBackgound = {
  backgroundColor: '#eeeeee'
};

export const checkCircleIconStyle = { marginLeft: 1, color: 'primary.main' };

export const verificationsButtonsWrapper = {
  display: 'flex',
  justifyContent: 'space-between',
  height: '40px',
  marginTop: 2
};

export const modalButtonsWrapper = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2
};

export const verificationContentWrapper = {
  display: 'flex',
  justifyContent: 'center',
  gap: 2,
  maxHeight: 'calc(100vh - 250px)'
};

export const zoomButtonsWrapper = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: '4px'
};

export const verificationFormFieldsWrapper = {
  display: 'flex',
  gap: 2
};

export const verificationFormFields = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2
};

export const verificationFormItem = {
  flex: 1,
  minHeight: 70
};

export const verificationFormItemNoHeight = {
  flex: 1
};

export const verificationFormItemFields = {
  borderBottom: '1px solid #ccc',
  paddingBottom: 2,
  '&:last-of-type': {
    borderBottom: 0,
    paddingBottom: 0
  }
};

export const verificationFieldsWrapper = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 3,
  width: '100%'
};

export const verificationProductsWrapper = {
  display: 'flex',
  alignItems: 'end',
  flexDirection: 'column',
  gap: 3
};

export const largeVerificationFieldWidth = {
  minWidth: '224px',
  width: '66%'
};

export const mediumVerificationFieldWidth = {
  width: '50%'
};

export const fullWidth = {
  width: '100%'
};

export const smallVerificationFieldWidth = {
  minWidth: '100px',
  width: '100%'
};

export const extraSmallVerificationFieldWidth = {
  minWidth: '100px',
  width: '31%'
};

export const processedInvoiceLabel = {
  color: 'rgb(7, 141, 238)',
  fontWeight: 600
};

export const nonMachineReadableLabel = {
  color: '#F44336',
  fontWeight: 600
};

export const actionButtonsWrapper = {
  display: 'flex',
  gap: 2,
  justifyContent: 'end'
};

export const actionButtonsWithWarningWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  gap: 1
};

export const warningIcon = {
  color: '#FFB302',
  fontSize: '24px'
};

export const verifyButtons = {
  background: '#87cefa',
  color: '#ffffff',
  boxShadow: '0px 2px 1px #00000026',
  '&:hover': {
    background: '#45aced'
  },
  '&:disabled': {
    background: '#d3d3d3'
  }
};

export const lineItemsTableContainer = {
  maxHeight: '300px',
  overflowY: 'auto',
  // tighter horizontal cell padding keeps the line-item columns closer together
  '& th, & td': {
    px: 1
  }
};

export const lineItemsTableHeaderRow = {
  backgroundColor: '#f9fafb'
} as const;

export const lineItemsTableHeaderCell = {
  fontWeight: 600,
  textTransform: 'uppercase'
} as const;

export const lineItemsFooterRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  borderTop: '1px solid #f0f0f0',
  paddingTop: 1
};

export const lineItemsStatusBanner = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: '0.5rem 0.75rem',
  borderRadius: '0.5rem',
  backgroundColor: '#fefce8',
  color: '#a16207'
};

// Inline editable fields in the Line items table: quiet by default, blue 2 px
// focus border (AC-9). Values are tuned to the design system mockup.
export const lineItemsEditableField = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #1976d2'
    }
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#e5e7eb'
  }
} as const;

export const lineItemsQuantityField = {
  ...lineItemsEditableField,
  width: 72
} as const;

export const lineItemsDescriptionField = {
  ...lineItemsEditableField,
} as const;

export const lineItemsUnitPriceField = {
  ...lineItemsEditableField,
  width: 104
} as const;

export const warningFieldStyle = {
  '.MuiFormLabel-root': {
    color: '#ff9800 !important'
  },
  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #ff9800'
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid #ff9800 !important'
  }
};

export const errorFieldStyle = {
  '.MuiFormLabel-root': {
    color: '#ff0000'
  },
  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #ff0000'
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid #ff0000'
  }
};

export const overviewTypographyStyle = {
  textAlign: 'left',
  fontSize: '0.875rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export const overviewTypographyLabelStyle = {
  paddingLeft: 2,
  textAlign: 'left',
  fontWeight: '600',
  fontSize: '0.875rem',
  whiteSpace: 'nowrap'
};

export const overviewTypographyContainerStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  mb: 1,
  fontSize: '0.875rem'
};
